import { toMinor, MONEY_DP } from "@hisense/shared";

/**
 * Parse a user-typed money string → integer storage units. Strips thousands
 * separators, accepts a locale comma-decimal (vi/zh), and REJECTS anything
 * that isn't a clean number — never silently coerces "1,234.56" → 1 or
 * garbage → 0. Up to 4 decimals: sub-cent unit prices are normal here.
 */
export function parseMoneyMajor(raw: string): { minor?: number; invalid?: boolean } {
  let v = raw.trim().replace(/\s/g, "");
  if (v === "") return {};
  if (v.includes(".") && v.includes(",")) v = v.replace(/,/g, ""); // 1,234.56 → 1234.56
  else if (v.includes(",") && !v.includes(".")) v = v.replace(",", "."); // 12,50 → 12.50
  if (!new RegExp(`^\\d+(\\.\\d{1,${MONEY_DP}})?$`).test(v)) return { invalid: true };
  return { minor: toMinor(parseFloat(v)) };
}

export function parseIntField(raw: string): { value?: number; invalid?: boolean } {
  const v = raw.trim();
  if (v === "") return {};
  if (!/^\d+$/.test(v)) return { invalid: true };
  return { value: parseInt(v, 10) };
}

/**
 * A PERCENT — stored as percent × 100 (12.5% → 1250). NOT money: it must never
 * go through parseMoneyMajor/MONEY_SCALE. Same contract as parseMoneyMajor:
 * reject junk, never coerce to 0. Used by the PI "LESS (%)" discount and the
 * purchase-order tax rate.
 */
export function parsePercent(raw: string): { value?: number; invalid?: boolean } {
  const s = raw.trim().replace(",", ".");
  if (s === "") return {};
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(s)) return { invalid: true };
  const pct = parseFloat(s);
  if (pct > 100) return { invalid: true };
  return { value: Math.round(pct * 100) };
}

/** Plain edit-field form of a percent×100 value: 1250 → "12.5", 0 → "". */
export const percentToInput = (x100: number) => (x100 ? String(Math.round(x100) / 100) : "");
